<template>
  <Modal v-model="visible" title="上传供应商结算单" :footer-hide="true" :mask-closable="false" class="my-modal top" width="800px">
    <Form ref="formValidate" :label-width="100" :model="searchParams" :rules="ruleValidate">
      <FormItem label="上传文件" prop="upload">
        <div class="uploadBtn">
          <div class="fileName" v-if="file !== null">{{ file.name }}</div>
          <Upload :before-upload="handleUpload" action="/" accept=".xls,.XLS" ref="upload">
            <Button v-if="file !== null" type="primary">重传</Button>
            <Button v-else type="primary">上传</Button>
          </Upload>
        </div>
      </FormItem>
      <FormItem label="结算单名称" prop="name">
        <Input v-model="searchParams.name" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="供应商类型" prop="supplierType">
        <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
          <Radio label="">全部</Radio>
          <Radio label="1">保险公司</Radio>
          <Radio label="2">合作通道</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="上游供应商" prop="supplierIds" v-if="searchParams.supplierType">
        <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
          <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
        </Select>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="cancel()">取消</Button>
      <Button type="primary" @click="submit()">确定</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      searchParams: {},
      ruleValidate: {
        upload: [{ required: true, message: '请上传文件', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'blur' }],
      },
      file: null,
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    handleUpload(file) {
      this.file = file;
      return false;
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/list'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
    },
    cancel(){
      this.visible = false
    },
    submit(){
      this.visible = false
      this.$parent.nextStep()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-body {
  padding-top: 20px !important;
}

.fileName {
  margin-right: 20px;
}

.uploadBtn {
  display: flex;
}
</style>